import 'react';
import {Typography} from '@mui/material';
import type {IdleAutoSaveStatus} from '@/hooks/useIdleAutoSave';

export interface AutoSaveStatusProps {
  status: IdleAutoSaveStatus;
  lastSavedAt?: Date | null;
}

function formatTime(d: Date): string {
  return d.toLocaleTimeString([], {hour: 'numeric', minute: '2-digit'});
}

/**
 * Subtle status text for idle auto-save (footer next to Save/Update).
 * Always reserves width so idle→pending does not shift layout and steal input focus.
 */
export function AutoSaveStatus({status, lastSavedAt}: AutoSaveStatusProps) {
  let text = '';
  let color: string = 'text.secondary';

  switch (status) {
    case 'pending':
      text = 'Unsaved changes…';
      break;
    case 'saving':
      text = 'Auto-saving…';
      break;
    case 'saved':
      text = lastSavedAt ? `Saved ${formatTime(lastSavedAt)}` : 'Saved';
      color = 'success.main';
      break;
    case 'error':
      text = 'Auto-save failed';
      color = 'warning.main';
      break;
    default:
      text = '';
      break;
  }

  return (
    <Typography
      variant="caption"
      sx={{
        mr: 2,
        color,
        alignSelf: 'center',
        minWidth: 140,
        visibility: text ? 'visible' : 'hidden',
        whiteSpace: 'nowrap',
      }}
    >
      {text || 'Unsaved changes…'}
    </Typography>
  );
}

